import "parsleyjs";
import "parsleyjs/dist/i18n/ru.js";

const htmlDate = 'YYYY-MM-DD';

$(function () {
	Parsley
		.addValidator('ru', {
			requirementType: 'string',
			validateString : function (value, requirement) {
				const regex = /^[а-яё\s\-']+$/i;
				return regex.test(value.trim());
			}
		})
		.addValidator('email', {
			requirementType: 'string',
			validateString : function (value, requirement) {
				const regex = /^[a-z\d.!#$%&'*+\/=?^_`{|}~-]+@[a-zа-яё\d](?:[a-zа-яё\d-]{0,61}[a-zа-яё\d])?\.(?:[a-zа-яё\d](?:[a-zа-яё\d-]{0,61}[a-zа-яё\d])?){2}$/i;
				return regex.test(value.trim());
			},
			messages       : {
				ru: 'Введите корректный Email',
			}
		})
		.addValidator('dateiso', {
			requirementType: 'string',
			priority       : 2,
			validateString : function (value, requirement) {
				if (value) {
					return moment(value, htmlDate, true).isValid() &&
						moment(value, htmlDate).isAfter(moment('01-01-1900', 'DD-MM-YYYY'), 'year');
				}
			}
		})
		.addValidator('equalTo', {
			requirementType: 'string',
			validateString : (function () {
				var fieldsWithHandlers = [];
				return function (val, el, parsleyField) {
					var $equalElement = $(el),
						fieldId       = parsleyField.__id__; //Опасно использовать приватные переменные плагина
					if (fieldsWithHandlers.indexOf(fieldId) < 0) {
						$equalElement.on("input", function () {
							parsleyField.validate();
						});
						fieldsWithHandlers.push(fieldId);
					}
					return val === $equalElement.val();
				}
			})()
		})
		.addValidator('maxyearsoffset', {
			priority       : 1,
			requirementType: 'string',
			validateString : function (val, el) {
				if (!val) {
					return false;
				}
				return moment().diff(moment(val, htmlDate, true), 'year') >= parseInt(el);
			}
		});


	const $form = $("form");

	$form.parsley({
		validationThreshold: 0,
		trigger            : 'keyup',
		classHandler       : function (ParsleyField) {
			return $(ParsleyField.$element.parents('.js-field'));
		},
		errorsContainer    : function (ParsleyField) {
			const $fieldSet = $(ParsleyField.$element.parents('.js-field'));
			if ($fieldSet.length > 0) {
				return $fieldSet.find('.js-errors');
			}
			return ParsleyField;
		},
		errorsWrapper      : '<ul class="errors"></ul>',
		errorClass         : 'field--error',
		successClass       : 'field--success',
		errorTemplate      : '<li class="errors__item"></li>'
	});
});



// WEBPACK FOOTER //
// ./static/components/Parsley.js